export default __webpack_public_path__ + "static/media/prisma-habibs.6003ae66.svg";